export const DEPARTMENTS = [
  { key: "design", label: "Design" },
  { key: "bim", label: "BIM" },
  { key: "production", label: "Production" },
  { key: "qaqc", label: "QA/QC" },
  { key: "logistics", label: "Logistics" },
  { key: "site", label: "Site" },
];

export const STATUS_VALUES = {
  design: ["Not Started", "In Design", "Approved", "Revision Required", "Hold"],
  bim: ["Not Started", "In Design", "Published", "Revision Required"],
  production: ["Not Started", "In Production", "Completed", "Hold"],
  qaqc: ["Not Inspected", "Passed", "Failed"],
  logistics: ["Not Shipped", "Shipped", "Arrived"],
  site: ["Not Installed", "Installed"],
};

export const DEFAULT_STATUS = {
  design: "Not Started",
  bim: "Not Started",
  production: "Not Started",
  qaqc: "Not Inspected",
  logistics: "Not Shipped",
  site: "Not Installed",
};

// RAL Classic references: 4006 traffic purple, 6038 luminous green,
// 3020 traffic red, 2003 pastel orange, 5012 light blue.
export const STATUS_COLORS = {
  design: {
    "Not Started": "#64748B",
    "In Design": "#A03472",
    Approved: "#00BB2D",
    "Revision Required": "#CC0605",
    Hold: "#FF7514",
  },
  bim: {
    "Not Started": "#64748B",
    "In Design": "#A03472",
    Published: "#00BB2D",
    "Revision Required": "#CC0605",
  },
  production: {
    "Not Started": "#64748B",
    "In Production": "#A03472",
    Completed: "#00BB2D",
    Hold: "#FF7514",
  },
  qaqc: { "Not Inspected": "#64748B", Passed: "#00BB2D", Failed: "#CC0605" },
  logistics: {
    __null__: "#64748B",
    "Not Shipped": "#64748B",
    Shipped: "#0089B6",
    Arrived: "#00BB2D",
  },
  site: { "Not Installed": "#64748B", Installed: "#00BB2D" },
};

// Mirrors app/workflow/rules.py REASON_REQUIRED — the backend re-validates it.
export const REASON_REQUIRED = [
  "design|Hold",
  "design|Revision Required",
  "bim|Revision Required",
  "production|Hold",
  "qaqc|Failed",
];

export const needsReason = (department, status) =>
  REASON_REQUIRED.includes(`${department}|${status}`);

export const ISSUE_STATUSES = ["Open", "In Progress", "Closed"];export const ISSUE_PRIORITIES = ["Low", "Medium", "High", "Critical"];
export const ISSUE_TYPES = [
  "Design",
  "BIM",
  "Production",
  "Quality",
  "Logistics",
  "Site",
  "NCR",
  "Other",
];

export const SHIPPING_METHODS = ["By Truck", "By Container"];

export const ISSUE_TYPE_COLORS = {  NCR: "#DC2626",
  Design: "#6366F1",
  BIM: "#0EA5E9",
  Production: "#F59E0B",
  Quality: "#A855F7",
  Logistics: "#14B8A6",
  Site: "#F97316",
  Other: "#64748B",
};

/** NCR always wins so a red "!" is never hidden behind another issue colour. */
export function issueMarkerColor(types) {
  const list = types || [];
  if (list.includes("NCR")) return ISSUE_TYPE_COLORS.NCR;
  for (const type of ISSUE_TYPES) {
    if (list.includes(type)) return ISSUE_TYPE_COLORS[type];
  }
  return ISSUE_TYPE_COLORS.Other;
}

export const ROLE_LABELS = {
  design: "Design",
  bim: "BIM",
  production: "Production",
  qaqc: "QA/QC",
  logistics: "Logistics",
  site: "Site",
  planning: "Planning",
  lead: "Lead",
  pm: "Project Manager",
  admin: "Admin",
  procurement: "Procurement",
  guest: "Guest",
};

export const TASK_STATUSES = ["To Do", "In Progress", "Done"];
export const TASK_PRIORITIES = ["Low", "Normal", "High", "Urgent"];

export const TASK_DEPARTMENTS = [
  { key: "all", label: "All" },
  { key: "design", label: "Design" },
  { key: "bim", label: "BIM" },
  { key: "production", label: "Production" },
  { key: "qaqc", label: "QA/QC" },
  { key: "logistics", label: "Logistics" },
];

export function statusColor(department, value) {
  const table = STATUS_COLORS[department] || {};
  return table[value == null ? "__null__" : value] || "#64748B";
}

/** Applies the admin-configured palette from /meta on top of the built-in defaults. */
export function applyStatusColors(byDepartment) {
  Object.entries(byDepartment || {}).forEach(([department, colors]) => {
    if (!STATUS_COLORS[department]) return;
    Object.entries(colors || {}).forEach(([status, hex]) => {
      if (hex) STATUS_COLORS[department][status] = hex;
    });
  });
}

export function statusLabel(value) {
  return value == null || value === "" ? "—" : value;
}

// Factory workspace statuses — the only writer of the main Production status.
export const FACTORY_STATUSES = [
  "Awaiting Cutting",
  "Cut",
  "CNC Machined",
  "Pressed",
  "Glazed",
  "Completed",
];

// RAL: 1026 luminous yellow, 2005 luminous orange, 4006 traffic purple,
// 5012 light blue, 6038 luminous green. Awaiting Cutting keeps the normal look.
export const FACTORY_STATUS_COLORS = {
  "Awaiting Cutting": null,
  Cut: "#FFFF00",
  "CNC Machined": "#FF4D00",
  Pressed: "#A03472",
  Glazed: "#3B83BD",
  Completed: "#00BB2D",
};
